/* eslint-disable @typescript-eslint/no-explicit-any */
import { t } from "i18next";
import styled from "styled-components";

import React from "react";
import BTable from "react-bootstrap/Table";
import { usePagination, useRowSelect, useTable } from "react-table";

import { Pagination } from "./Pagination";

type PropsType = {
    columns: TableColumnsType[];
    // eslint-disable-next-line
    data: any[];
};

const Styles = styled.div`
    table {
        thead {
            font: normal bold 22px/55px Bebas Neue;
            letter-spacing: 0.88px;
            color: #0a0a0a;
            text-align: center;
        }

        tbody td {
            text-align: center;
            font: normal 12px/28px Arial;
            letter-spacing: 0px;
            vertical-align: middle;
        }
        tbody td:nth-child(4) {
            width: 180px;
        }
    }
`;

export function Table({ columns, data }: PropsType): JSX.Element {
    const ITEMS_PER_PAGE = 7;

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex },
    } = useTable(
        {
            columns,
            data: data,
            initialState: { pageIndex: 0 },
        },
        usePagination,
        useRowSelect
    );

    React.useEffect(() => {
        setPageSize(ITEMS_PER_PAGE);
    }, [setPageSize]);

    return (
        <React.Fragment>
            <Styles>
                <BTable
                    responsive
                    {...getTableProps()}
                    style={{
                        display: "block",
                    }}
                >
                    <thead
                        className="d-flex w-100"
                        style={{
                            position: "sticky",
                            top: "0px",
                            background:
                                "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                            borderBottom: "2px solid #e2e8f0",
                            zIndex: 10,
                        }}
                    >
                        {headerGroups.map((headerGroup: any) => {
                            const { key: headerGroupKey } =
                                headerGroup.getHeaderGroupProps();
                            return (
                                <tr
                                    className="d-flex justify-content-between"
                                    key={headerGroupKey}
                                    {...headerGroup.getHeaderGroupProps()}
                                    style={{
                                        width: "100%",
                                    }}
                                >
                                    {headerGroup.headers.map(
                                        (column: any, index: number) => {
                                            const { key: headerKey } =
                                                column.getHeaderProps();
                                            return (
                                                <th
                                                    key={headerKey}
                                                    {...column.getHeaderProps()}
                                                    style={{
                                                        flex: 1,
                                                        padding: "1rem",
                                                        borderBottom: "none",
                                                        borderRight:
                                                            index <
                                                            headerGroup.headers
                                                                .length -
                                                                1
                                                                ? "1px solid #e2e8f0"
                                                                : "none",
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                        color: "#374151",
                                                        textTransform:
                                                            "uppercase",
                                                        letterSpacing: "0.5px",
                                                        background:
                                                            "transparent",
                                                    }}
                                                >
                                                    {column.render("Header")}
                                                </th>
                                            );
                                        }
                                    )}
                                </tr>
                            );
                        })}
                    </thead>
                    <tbody
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            overflowY: "scroll",
                            height: "75vw",
                            scrollbarWidth: "none",
                            background:
                                "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                        }}
                        {...getTableBodyProps()}
                    >
                        {page.length ? (
                            // eslint-disable-next-line
                            page.map((row: any) => {
                                prepareRow(row);
                                const { key: rowKey } = row.getRowProps();

                                return (
                                    <tr
                                        className="d-flex justify-content-between"
                                        key={rowKey}
                                        {...row.getRowProps()}
                                        style={{
                                            width: "100%",
                                        }}
                                    >
                                        {/* eslint-disable-next-line */}
                                        {row.cells.map((cell: any) => {
                                            const { key: cellKey } =
                                                cell.getCellProps();
                                            return (
                                                <td
                                                    className="white-space-nowrap three-lines-preview-text d-flex justify-content-center align-items-center"
                                                    key={cellKey}
                                                    {...cell.getCellProps()}
                                                    style={{
                                                        width: "180px",
                                                    }}
                                                >
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr
                                style={{
                                    width: "100%",
                                }}
                            >
                                <td
                                    colSpan={headerGroups[0]?.headers?.length}
                                    style={{
                                        textAlign: "center",
                                        width: "100%",
                                    }}
                                >
                                    {t("No data")}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </BTable>
            </Styles>
            {data.length > ITEMS_PER_PAGE ? (
                <Pagination
                    canPreviousPage={canPreviousPage}
                    canNextPage={canNextPage}
                    pageOptions={pageOptions}
                    pageCount={pageCount}
                    gotoPage={gotoPage}
                    nextPage={nextPage}
                    previousPage={previousPage}
                    pageIndex={pageIndex}
                />
            ) : null}
        </React.Fragment>
    );
}
